import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/scenarios')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/scenario' })
  },
})
